// extracted by mini-css-extract-plugin
export default {"voucher":"Voucher_voucher__N0aOZ","closeIcon":"Voucher_closeIcon__gyufy","selector":"Voucher_selector__h1cQV"};